export default function Services() {
  const services = [
    {
      icon: 'ri-home-4-line',
      title: 'Vaciado completo',
      description: 'Retiramos todos los muebles, enseres y objetos del piso de forma profesional y eficiente.'
    },
    {
      icon: 'ri-recycle-line',
      title: 'Gestión de residuos',
      description: 'Nos encargamos del reciclaje y eliminación responsable de todos los materiales.'
    },
    {
      icon: 'ri-truck-line',
      title: 'Transporte incluido',
      description: 'Disponemos de vehículos propios para el traslado de todos los enseres.'
    },
    {
      icon: 'ri-time-line',
      title: 'Servicio rápido',
      description: 'Completamos el vaciado en el menor tiempo posible, adaptándonos a tus necesidades.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Totalmente asegurado',
      description: 'Contamos con todos los seguros necesarios para garantizar tu tranquilidad.'
    },
    {
      icon: 'ri-money-euro-circle-line',
      title: 'Presupuesto sin compromiso',
      description: 'Te ofrecemos un presupuesto detallado y transparente sin ningún compromiso.'
    }
  ];

  return (
    <section id="servicios" className="py-12 sm:py-16 md:py-20 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4 px-2">
            Nuestros servicios de vaciado de pisos
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto px-4">
            En VPB ofrecemos un <a href="https://barcelona.nom.es/" target="_blank" rel="noopener noreferrer" className="text-teal-600 hover:text-teal-700 underline cursor-pointer">servicio integral de vaciado de pisos en Barcelona</a>, adaptado a tus necesidades específicas. Consulta nuestra <a href="/politica-privacidad" className="text-teal-600 hover:text-teal-700 underline cursor-pointer">política de privacidad</a> para conocer cómo protegemos tus datos personales.
          </p>
        </div>

        {/* Imagen de ejemplo */}
        <div className="mb-12 sm:mb-16 rounded-xl sm:rounded-2xl overflow-hidden shadow-xl">
          <img
            src="https://static.readdy.ai/image/ddc6a6c51837b652ebd36d1bdad447b7/a11e81645476fbd776b5cbc57111252d.jpeg"
            alt="Ejemplo de piso para vaciar en Barcelona"
            className="w-full h-64 sm:h-80 md:h-96 object-cover object-center"
            loading="lazy"
            decoding="async"
            width="1200"
            height="384"
          />
          <div className="bg-gray-50 p-4 sm:p-6 text-center">
            <p className="text-sm sm:text-base text-gray-700 font-medium px-2">
              Nos encargamos de pisos en cualquier estado - Servicio profesional garantizado
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-xl p-6 sm:p-8 hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-12 h-12 sm:w-14 sm:h-14 bg-teal-600 rounded-lg flex items-center justify-center mb-4 sm:mb-6">
                <i className={`${service.icon} text-xl sm:text-2xl text-white`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                {service.title}
              </h3>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 sm:mt-16 text-center">
          <p className="text-base sm:text-lg text-gray-600 mb-6 px-4">
            ¿Necesitas más información sobre nuestros servicios? <a href="#contacto" className="text-teal-600 hover:text-teal-700 font-semibold underline cursor-pointer">Solicita tu presupuesto gratuito</a> y te responderemos en menos de 24 horas.
          </p>
        </div>
      </div>
    </section>
  );
}